const orders = [{
    "id":5364,
    "date":'Mar 27,2023',
    "status": 'Delivered',
    "total":40000,
    "quantity":2
    },
  {
    "id":5366,
    "date":'Jul 17,2023',
    "status": 'On Hold',
    "total":20000,
    "quantity":4
  }]

export default orders;